module.exports = __webpack_public_path__ + "static/media/infoIconrightpanel.9c5e0549.svg";